import Observer from '../../common/scripts/observer';

const observer = new Observer();

/**
 * Табы
 * @param {Object} element - обератка всего блока
 * @constructor
 */
class Tabs {
    constructor() {
        // нода родителя табов (элементов переключения табов)
        this.tabsParent = {};

        // массив табов (элементов переключения табов)
        this.tabs = [];

        // нода родителя контента табов
        this.contentsParent = {};

        // массив элементов с контентов табов
        this.contents = [];

        // записываем данные таба на котором произошло событие клика
        this.dataTab = {};

        // Класс активного(выбранного) таба
        this.active = 'is-active';

        // Класс крытого таба
        this.hide = 'is-hide';

        // Класс задисабленного таба
        this.disabled = 'is-disabled';
    }

    init(options) {
        this.tabsParent = document.querySelector(options.element) || null;

        this.tabsItemClass = options.tabsItemClass || '.b-tabs__item';
        this.tabsContentItemClass = options.tabsContentItemClass || '.b-tabs-content__item';

        // Проверка на наличие табов
        if (!this.tabsParent) {
            console.error('Need target element - ' +
                'https://kelnik.gitbooks.io/kelnik-documentation/front-end/components/tabs.html');

            return;
        }

        // находим все табы и приводим коллекцию нод к массиву. Для работы с forEach в ИЕ.
        this.tabs = Array.from(this.tabsParent.querySelectorAll(this.tabsItemClass));

        this.contentsParent = document.querySelector(`.${this.tabsParent.dataset.content}`);

        // находим все элементы контента и приводим коллекцию нод к массиву. Для работы с forEach в ИЕ.
        this.contents = Array.from(this.contentsParent.querySelectorAll(this.tabsContentItemClass));

        this.bindEvents();
    }

    /**
     * Вешаем слушатель на табы
     */
    bindEvents() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.toggleTab.bind(this));
        });
    }

    /**
     * Переключаем табы
     * @param {event} event - передаем событие
     */
    toggleTab(event) {
        event.preventDefault();
        const tab = event.currentTarget;

        if (tab.classList.contains(this.disabled)) {
            return;
        }

        this.setData(tab);
        this.changeState();
        observer.publish('tabs:change');
    }

    /**
     * Получаем значения data атрибутов таба
     * @param {node} activeTab - нода таба по которому произошло событие клика
     */
    setData(activeTab) {
        this.dataTab = {
            tab : activeTab,
            id  : activeTab.dataset.tab,
            url : activeTab.getAttribute('href'),
            ajax: activeTab.dataset.ajax
        };
    }

    /**
     * Проверяем наличие класса is-disabled у жмакнутого таба
     * @returns {boolean} false or true
     */
    isDisableTab() {
        return this.dataTab.tab.classList.contains(this.disabled);
    }

    /**
     * Меняем состояние табов
     */
    changeState() {
        // ничего не делаем если таб неактивен
        if (this.isDisableTab()) {
            return;
        }

        // меняем состояние табов
        this.tabs.forEach((element) => {
            if (element.dataset.tab === this.dataTab.id) {
                element.classList.add(this.active);

                return;
            }
            element.classList.remove(this.active);
        });

        // и показываем нужный контент
        this.contents.forEach((element) => {
            if (element.dataset.tabContent === this.dataTab.id) {
                element.classList.add(this.active);

                return;
            }
            element.classList.remove(this.active);
        });
    }
}

export default Tabs;
